export default {
	ask_malik: {
		en: "Ask Malik",
		ar: "اسأل مالك",
	},
	my_name_malik: {
		en: "Hello ! My name is Malik",
		ar: "مرحبا ! انا اسمي مالك",
	},
	dld_virtual_asst: {
		en: "Dubai Land Department’s Virtual Assistant",
		ar: "المساعد الافتراضي لدائرة الأراضي والأملاك في دبي",
	},
	ask_me_ques: {
		en: "Ask me any question related to DLD and its services",
		ar: "اطرح عليّ أي سؤال يتعلق بدائرة الأراضي و الأملاك وخدماتها",
	},
	lets_get_started: {
		en: "Let's Get Started",
		ar: "هيا نبدأ",
	},
	type_query_speak: {
		en: "Type your query or speak",
		ar: "اكتب استفسارك أو تحدث",
	},
	following_questions: {
		en: "Following questions matched your query.",
		ar: "الأسئلة التالية تطابق استفسارك.",
	},
	following_related_questions: {
		en: "Following are the related questions and answers.",
		ar: "فيما يلي الأسئلة والأجوبة ذات الصلة.",
	},
	ask_malik_no_match_post: {
		en: "We could not find any answer matching your query. Try with a different query or post your question.",
		ar: "لم نتمكن من العثور على أي إجابة تطابق استفسارك. حاول باستفسار مختلف أو انشر سؤالك.",
	},
	ask_malik_fail: {
		en: "An error occurred, Please try again.",
		ar: "حدث خطأ بالنظام، الرجاء إعادة المحاولة.",
	},
	relate_qa: {
		en: "Related Q & A",
		ar: "الأسئلة والأجوبة ذات الصلة",
	},
	ask_a_question: {
		en: "Ask a Question",
		ar: "اسأل سؤال",
	},
	share_qa: {
		en: "Share this Q & A",
		ar: "شارك هذه الأسئلة والأجوبة",
	},
	was_answer_helpful: {
		en: "Was this answer helpful?",
		ar: "هل كانت هذه الإجابة مفيدة؟",
	},
	thank_you: {
		en: "Thank you",
		ar: "شكرا لك",
	},
	question: {
		en: "Question",
		ar: "سؤال",
	},
	answer: {
		en: "Answer",
		ar: "جواب",
	},
	enter_question: {
		en: "Enter your question here",
		ar: "أدخل سؤالك هنا",
	},
	ask_a_question_success: {
		en: "Your question has been posted successfully. We will send you an email with the answer.",
		ar: "تم نشر سؤالك بنجاح. سنرسل لك بريدًا إلكترونيًا مع الإجابة.",
	},
};
